import axios from "axios";
import { getToken } from "../Utlis/UpdateUserState";

const login = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/login/`,
      data,
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

const verifyTwoFactor = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/2fa/verify/`,
      data,
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

const resendTwoFactor = async (tempToken) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/2fa/resend/`,
      { temp_token: tempToken },
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

const forgotPassword = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/forgot-password/`,
      data,
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

const resendForgotPassword = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/forgot-password/resend/`,
      data,
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

const resetPassword = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/reset-password/`,
      data,
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

const refresh = async (refreshToken) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/refresh-token/`,
      { refresh: refreshToken },
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      },
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

const logout = async (refreshToken) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/logout/`,
      { refresh: refreshToken },
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      },
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

export {
  login,
  verifyTwoFactor,
  resendTwoFactor,
  forgotPassword,
  resendForgotPassword,
  resetPassword,
  refresh,
  logout,
};
